import { Button, Icon, PageTitle } from '@pwc/pwc-deals-ui';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { PowerBiIngestionModalBody } from './PowerBiIngestionModalBody';
import { PowerPointIngestionModalBody } from './PowerPointIngestion/PowerPointIngestionModalBody';
import { StartIngestionModalBody } from './StartIngestionModalBody';

import './IngestLibraryItemModal.scss';

const Body = ({
  modalContentType,
  handleStartClick,
  handleSuccessfulIngestion,
  pbiItems,
  projectId,
  ingestedPowerPointGroups,
}) => {
  switch (modalContentType) {
    case 'start':
      return <StartIngestionModalBody handleStartClick={handleStartClick} />;
    case 'PowerPoint':
      return (
        <PowerPointIngestionModalBody
          handleSuccessfulIngestion={handleSuccessfulIngestion}
          ingestedPowerPointGroups={ingestedPowerPointGroups}
        />
      );
    case 'PowerBI':
      return (
        <PowerBiIngestionModalBody
          pbiItems={pbiItems}
          handleSuccessfulIngestion={handleSuccessfulIngestion}
          projectId={projectId}
        />
      );
    default:
      return null;
  }
};

const IngestLibraryItemModal = ({
  show,
  handleCancel,
  handleSuccessfulIngestion,
  pbiItems,
  projectId,
  ingestedPowerPointGroups,
}) => {
  const [modalContentType, setModalContentType] = useState('start');
  const [showBack, setShowBack] = useState(false);
  const [header, setHeader] = useState('');
  const handleStartClick = (selectedType) => setModalContentType(selectedType);

  useEffect(() => {
    switch (modalContentType) {
      case 'start':
        setShowBack(false);
        break;
      case 'PowerPoint':
        setShowBack(true);
        break;
      case 'PowerBI':
        setShowBack(true);
        break;
      default:
        setShowBack(false);
    }
  }, [modalContentType]);

  useEffect(() => {
    switch (modalContentType) {
      case 'start':
        setHeader('Import data');
        break;
      case 'PowerPoint':
        setHeader('Import from PowerPoint');
        break;
      case 'PowerBI':
        setHeader('Import from Power BI');
        break;
      default:
        setHeader('');
    }
  }, [modalContentType]);

  return (
    <Modal className="import-modal" show={show} onHide={handleCancel}>
      <Modal.Header closeButton>
        {showBack && (
          <div className="back-button">
            <Button
              className="button-menu back-button mb-3"
              type="button"
              onClick={() => setModalContentType('start')}
              data-testid="back-button"
            >
              <Icon
                name="left-chevron"
                width={14}
                className="fill icon-orange"
              />
              Back
            </Button>
          </div>
        )}
        <Modal.Title>
          <PageTitle title={header} size="h2" />
        </Modal.Title>
      </Modal.Header>
      <Body
        handleStartClick={handleStartClick}
        handleSuccessfulIngestion={handleSuccessfulIngestion}
        modalContentType={modalContentType}
        pbiItems={pbiItems}
        projectId={projectId}
        ingestedPowerPointGroups={ingestedPowerPointGroups}
      />
    </Modal>
  );
};

export default IngestLibraryItemModal;
